import React from 'react'
import {Form, Input, Button, Row, Col} from 'antd'
import Utils from '../../Utils/utils'

import Images from '../../Images'

const { TextArea } = Input;

function InvestorIntroForm(props) {
  const [form] = Form.useForm();

  const onFinish = values => {
    props.onSubmit(values);
  }

  return (
    <Form form={form} onFinish={onFinish} className="login-form" layout="vertical">

      <Row gutter={16}>
        <Col sm={24} xl={12}>
          <Form.Item
            name="name"
            rules={[{required: true, message: 'This field is required'}]}
          >
            <Input
              placeholder="Name"
              maxLength={100}
              prefix={<img src={Images.user} alt="" />}
              suffix={'*'}
            />
          </Form.Item>
        </Col>
        <Col sm={24} xl={12}>
          <Form.Item
            name="surname"
            rules={[{required: true, message: 'This field is required'}]}
          >
            <Input
              placeholder="Surname"
              maxLength={100}
              prefix={<img src={Images.user} alt="" />}
              suffix={'*'}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col sm={24} xl={12}>
          <Form.Item
            name="company"
            rules={[{required: true, message: 'This field is required'}]}
          >
            <Input
              placeholder="Company"
              maxLength={100}
              prefix={<img src={Images.briefcaseSm} alt="" />}
              suffix={'*'}
            />
          </Form.Item>
        </Col>
        <Col sm={24} xl={12}>
          <Form.Item
            name="job_position"
            rules={[{required: true, message: 'This field is required'}]}
          >
            <Input
              placeholder="Job Position"
              maxLength={100}
              prefix={<img src={Images.crosshairs} alt="" />}
              suffix={'*'}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col sm={24} xl={12}>
          <Form.Item
            name="email"
            rules={[
              {required: true, message: 'This field is required'},
              { type: 'email', message: 'Invalid email format' },
              { min: 5, message: 'Field must contain at least 5 characters' },
            ]}
            onKeyPress={e=>{if(e.charCode === 32) e.preventDefault()}}
            onBlur={e=>Utils.clearSpaces(e, 'email', form.setFieldsValue)}
          >
            <Input
              placeholder="Work Email"
              maxLength={100}
              prefix={<img src={Images.envelope} alt="" />}
              suffix={'*'}
            />
          </Form.Item>
        </Col>
        <Col sm={24} xl={12}>
          <Form.Item
            name="phone"
            rules={[
              {required: true, message: 'This field is required'},
              {pattern: /^\+?[0-9]{7,14}$/, message: 'Invalid format'},
              { min: 7, message: 'Field must contain at least 7 characters' },
            ]}
          >
            <Input
              placeholder="+447911123456"
              type="tel"
              maxLength={20}
              prefix={<img src={Images.mobile} alt="" />}
              suffix={'*'}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col sm={24} xl={{span: 12, offset: 6}}>
          <Form.Item
            name="linkedin_url"
            rules={[
              {required: true, message: 'This field is required'},
              {pattern: /linkedin.com/i, message: 'Field must contain "linkedin.com"'},
              { min: 12, message: 'Field must contain at least 12 characters' },
            ]}
          >
            <Input
              placeholder="URL Linkedin Profile"
              maxLength={100}
              prefix={<img src={Images.linkedin} alt="" />}
              suffix={'*'}
            />
          </Form.Item>
        </Col>
      </Row>

      <div className="separator"></div>

      <Form.Item
        name="introduction_message"
        rules={[
          {required: true, message: "This field is required"},
        ]}
      >
        <TextArea
          placeholder="Write a short introductory message (max 500 words)*"
          rows={8}
          maxLength={5000}
        />
      </Form.Item>

      <Button type="primary" htmlType="submit" className="btn-primary" style={{width: 217, marginTop: 32}}>
        Submit
      </Button>

    </Form>
  )
}

export default InvestorIntroForm
